import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CreateUserDto, UpdateUserDto, User } from '../models/api.models';

/**
 * Example service demonstrating the canonical pattern for API service creation.
 * Extends ApiService to inherit typed HTTP methods and consistent configuration.
 */
@Injectable({ providedIn: 'root' })
export class UserService extends ApiService {
  /**
   * Get all users.
   */
  getUsers(): Observable<User[]> {
    return this.get<User[]>('users');
  }

  /**
   * Get a single user by ID.
   */
  getUserById(id: number): Observable<User> {
    return this.get<User>(`users/${id}`);
  }

  /**
   * Create a new user.
   */
  createUser(dto: CreateUserDto): Observable<User> {
    return this.post<User>('users', dto);
  }

  /**
   * Update an existing user.
   */
  updateUser(id: number, dto: UpdateUserDto): Observable<User> {
    return this.put<User>(`users/${id}`, dto);
  }

  /**
   * Delete a user.
   */
  deleteUser(id: number): Observable<void> {
    return this.delete<void>(`users/${id}`);
  }
}